export const existingPaymentSystems = [
  'LedPay',
  'PaySpot',
  'Pay.Nl',
];
